export default __webpack_public_path__ + "static/media/cover.2f02b280.jpeg";